import { createContext } from "react";

const ContextQuestionsFieldsData = createContext<null | CompleoShared.Assessments.IQuestionsReturnData>(
    null
);

export default ContextQuestionsFieldsData;
